import React from 'react'
import logo from "../images/direSoftwareSmall.png"
import { useNavigate } from 'react-router-dom'
import "./css/Header.css"

export const SiteHeader = () => {

  const navigate = useNavigate();

  return (
    <header className='SiteHeader'>
        <img src={logo} width={125} className='logo' draggable="false" alt='The direSoftware logo'/>
        <div className='NavBar'>
            <button className='NavButton' onClick={() => navigate("/")}>Home</button>
            <button className='NavButton' onClick={() => navigate("/projects")}>Projects</button>
            <button className='NavButton' onClick={() => navigate("/privacy")}>Privacy</button>
            <button className='NavButton' onClick={() => navigate("/contact")}>Contact</button>
        </div>
    </header>
  )
}

export default SiteHeader;